/** The partner page (vaultplay.co/partners): for shops and agents, not players. */
export const PARTNERS_PATH = '/partners';

/** Same page, served at the root of this host so the address bar stays partners.vaultplay.co. */
export const PARTNERS_HOST = 'partners.vaultplay.co';

/** Player site. On the partners host, `/` is the partner page, so "go play" cannot stay in-app. */
export const PLAYER_ORIGIN = 'https://vaultplay.co';

export function isPartnersHost(hostname = globalThis.location?.hostname ?? ''): boolean {
  return hostname === PARTNERS_HOST;
}

/**
 * True on the partner page, where none of the player overlays (bonus popup, help strip…) show.
 * On partners.vaultplay.co the page is `/` as well as `/partners`.
 */
export function isPartnersPath(pathname: string, hostname = globalThis.location?.hostname ?? ''): boolean {
  if (pathname === PARTNERS_PATH || pathname.startsWith(`${PARTNERS_PATH}/`)) return true;
  return isPartnersHost(hostname) && pathname === '/';
}

/** In-app `/` on vaultplay.co; the player origin when this host is the partner page. */
export function playerHomeHref(hostname = globalThis.location?.hostname ?? ''): string {
  return isPartnersHost(hostname) ? `${PLAYER_ORIGIN}/` : '/';
}
